import { memo } from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { Accordion, AccordionTab } from "primereact/accordion";
import useMobile from "../../utils/useMobile";
import "./Footer.scss";

const APP_VERSION = "3.0.0";

const Footer = memo(({ config }) => {
  const isMobile = useMobile();

  const { logo = {}, socialLinks = [], columns = [], copy = "", canal = "" } = config || {};

  const footerGridTemplate = columns.length
    ? `minmax(190px, 1fr) repeat(${columns.length}, minmax(150px, 0.85fr))`
    : "minmax(190px, 1fr)";

  const renderFooterLink = (link, keyPrefix = "link") => {
    if (typeof link === "string") {
      return <span key={`${keyPrefix}-${link}`}>{link}</span>;
    }
    if (link.textOnly) {
      return <span key={`${keyPrefix}-${link.label}`} className="landing-footer-link landing-footer-text-only">{link.label}</span>;
    }
    if (link.to) {
      return <Link key={`${keyPrefix}-${link.label}`} to={`/info/${link.to}`} className="landing-footer-link">{link.label}</Link>;
    }
    return <a key={`${keyPrefix}-${link.label}`} href={link.href} target="_blank" rel="noreferrer noopener" className="landing-footer-link">{link.label}</a>;
  };

    const renderSocialButtons = () =>
      socialLinks.map((social) => (
        <Button size="large" style={{ color: "#fff" }} key={social.name} icon={social.icon} text as="a" href={social.href} target="_blank" rel="noreferrer noopener" aria-label={social.name} title={social.name}/>
      ));

  return (
    <footer className="landing-footer">
      {!isMobile ? (
        <div className="landing-footer-grid-scroll">
          <div className="landing-container landing-footer-grid landing-footer-grid-desktop" style={{ gridTemplateColumns: footerGridTemplate }}>
            <div className="landing-footer-brand">
              <Image src={logo.src} alt={logo.alt} />
              <div className="landing-social-links">{renderSocialButtons()}</div>
            </div>
            {columns.map((column) => (
              <div key={column.title} className="landing-footer-column">
                <h4><b>{column.title}</b></h4>
                {column.links.map((link) => renderFooterLink(link, `desktop-${column.title}`))}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="footer-mobile">
          <div className="footer-mobile-brand">
            <img src={logo.src} alt={logo.alt} className="footer-mobile-logo" />
            <div className="footer-mobile-social">{renderSocialButtons()}</div>
          </div>
          <Accordion className="footer-mobile-accordion">
            {columns.map((column) => (
              <AccordionTab key={column.title} header={column.title}>
                <div className="footer-mobile-links">
                  {column.links.map((link) => renderFooterLink(link, `mobile-${column.title}`))}
                </div>
              </AccordionTab>
            ))}
          </Accordion>
        </div>
      )}
      <div className="landing-footer-copy">{copy ? `${copy} · v${APP_VERSION}` : `v${APP_VERSION}`}{canal ? ` · ${canal}` : ""}</div>
    </footer>
  );
});

export default Footer;
